import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type BankAccountProps = {
    className?: string;
};

const BankAccount: FunctionComponent<BankAccountProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'bank-account'}
            viewBox="0 0 250 250"
        >
            <polygon points="126,0 0,37.1 0,54 250,54 250,37.1" />
            <rect x="108" y="72.5" width="36" height="107.5" />
            <rect x="36" y="72.5" width="36" height="107.5" />
            <rect x="27" y="198.5" width="198" height="17.5" />
            <rect y="232.5" width="250" height="17.5" />
            <rect x="180" y="72.5" width="36" height="107.5" />
        </svg>
    );
};

export default BankAccount;
